module.exports = __webpack_public_path__ + "img/main.4c2aa446.png";